import { render, staticRenderFns } from "./Deepseek.vue?vue&type=template&id=bdef801a&scoped=true&"
import script from "./Deepseek.vue?vue&type=script&lang=js&"
export * from "./Deepseek.vue?vue&type=script&lang=js&"
import style0 from "./Deepseek.vue?vue&type=style&index=0&id=bdef801a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdef801a",
  null
  
)

export default component.exports